import { History } from "history";

import {
  CreateTeacherAdminRequest,
  PaginateQuery,
  TeacherAdminDto,
} from "../../../interfaces";
import { Paginated } from "../../../models";
import { RoleEnum } from "../../../enums";

//#region Get Users

export const GET_TEACHER_ADMIN_USERS = "GET_TEACHER_ADMIN_USERS";
export const GET_TEACHER_ADMIN_USERS_SUCCESS: any =
  "GET_TEACHER_ADMIN_USERS_SUCCESS";
export const GET_TEACHER_ADMIN_USERS_ERROR: any =
  "GET_TEACHER_ADMIN_USERS_ERROR";

export interface GetTeacherAdminUsersAction {
  type: typeof GET_TEACHER_ADMIN_USERS;
  payload: {
    role: RoleEnum;
    request: PaginateQuery;
    history: History;
  };
}

export interface GetTeacherAdminUsersSuccessAction {
  type: typeof GET_TEACHER_ADMIN_USERS_SUCCESS;
  payload: Paginated<TeacherAdminDto>;
}

export interface GetTeacherAdminUsersErrorAction {
  type: typeof GET_TEACHER_ADMIN_USERS_ERROR;
  payload: any;
}
//#endregion

//#region Get User

export const GET_TEACHER_ADMIN_USER = "GET_TEACHER_ADMIN_USER";
export const GET_TEACHER_ADMIN_USER_SUCCESS: any =
  "GET_TEACHER_ADMIN_USER_SUCCESS";
export const GET_TEACHER_ADMIN_USER_ERROR: any = "GET_TEACHER_ADMIN_USER_ERROR";

export interface GetTeacherAdminUserAction {
  type: typeof GET_TEACHER_ADMIN_USER;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetTeacherAdminUserSuccessAction {
  type: typeof GET_TEACHER_ADMIN_USER_SUCCESS;
  payload: TeacherAdminDto;
}

export interface GetTeacherAdminUserErrorAction {
  type: typeof GET_TEACHER_ADMIN_USER_ERROR;
  payload: any;
}
//#endregion

//#region Add Teacher Admin User

export const ADD_TEACHER_ADMIN_USER = "ADD_TEACHER_ADMIN_USER";
export const ADD_TEACHER_ADMIN_USER_SUCCESS: any =
  "ADD_TEACHER_ADMIN_USER_SUCCESS";
export const ADD_TEACHER_ADMIN_USER_ERROR: any = "ADD_TEACHER_ADMIN_USER_ERROR";

export interface AddTeacherAdminUserAction {
  type: typeof ADD_TEACHER_ADMIN_USER;
  payload: {
    request: CreateTeacherAdminRequest;
    history: History;
  };
}

export interface AddTeacherAdminUserSuccessAction {
  type: typeof ADD_TEACHER_ADMIN_USER_SUCCESS;
  payload: null;
}

export interface AddTeacherAdminUserErrorAction {
  type: typeof ADD_TEACHER_ADMIN_USER_ERROR;
  payload: any;
}
//#endregion

//#region Update Teacher Admin User

export const UPDATE_TEACHER_ADMIN_USER = "UPDATE_TEACHER_ADMIN_USER";
export const UPDATE_TEACHER_ADMIN_USER_SUCCESS: any =
  "UPDATE_TEACHER_ADMIN_USER_SUCCESS";
export const UPDATE_TEACHER_ADMIN_USER_ERROR: any =
  "UPDATE_TEACHER_ADMIN_USER_ERROR";

export interface UpdateTeacherAdminUserAction {
  type: typeof UPDATE_TEACHER_ADMIN_USER;
  payload: {
    id: string;
    request: CreateTeacherAdminRequest;
    history: History;
  };
}

export interface UpdateTeacherAdminUserSuccessAction {
  type: typeof UPDATE_TEACHER_ADMIN_USER_SUCCESS;
  payload: null;
}

export interface UpdateTeacherAdminUserErrorAction {
  type: typeof UPDATE_TEACHER_ADMIN_USER_ERROR;
  payload: any;
}
//#endregion

//#region Delete User

export const DELETE_TEACHER_ADMIN_USER_CONSENT: any =
  "DELETE_TEACHER_ADMIN_USER_CONSENT";
export const DELETE_TEACHER_ADMIN_USER = "DELETE_TEACHER_ADMIN_USER";
export const DELETE_TEACHER_ADMIN_USER_SUCCESS: any =
  "DELETE_TEACHER_ADMIN_USER_SUCCESS";
export const DELETE_TEACHER_ADMIN_USER_ERROR: any =
  "DELETE_TEACHER_ADMIN_USER_ERROR";

export interface DeleteTeacherAdminUserConsentAction {
  type: typeof DELETE_TEACHER_ADMIN_USER_CONSENT;
  payload: string;
}

export interface DeleteTeacherAdminUserAction {
  type: typeof DELETE_TEACHER_ADMIN_USER;
  payload: {
    id: string;
    history: History;
  };
}

export interface DeleteTeacherAdminUserSuccessAction {
  type: typeof DELETE_TEACHER_ADMIN_USER_SUCCESS;
  payload: null;
}

export interface DeleteTeacherAdminUserErrorAction {
  type: typeof DELETE_TEACHER_ADMIN_USER_ERROR;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetTeacherAdminUsersAction
  | GetTeacherAdminUsersSuccessAction
  | GetTeacherAdminUsersErrorAction
  | GetTeacherAdminUserAction
  | GetTeacherAdminUserSuccessAction
  | GetTeacherAdminUserErrorAction
  | AddTeacherAdminUserAction
  | AddTeacherAdminUserSuccessAction
  | AddTeacherAdminUserErrorAction
  | UpdateTeacherAdminUserAction
  | UpdateTeacherAdminUserSuccessAction
  | UpdateTeacherAdminUserErrorAction
  | DeleteTeacherAdminUserAction
  | DeleteTeacherAdminUserSuccessAction
  | DeleteTeacherAdminUserErrorAction;
